import * as qs from 'qs';
import ReverbCookie from './reverb_cookie';

const queryParams = qs.parse(window.document.location.search, { ignoreQueryPrefix: true });
const token = ReverbCookie.get('reverb_user_oauth_token') || queryParams.gt;

let authorization;
if (token) {
  authorization = `Bearer ${token}`;
}

export default authorization;



// WEBPACK FOOTER //
// ./javascripts/components/auth_token.js